const Hero = () => {
  return <div className=""></div>;
};

export default Hero;
